import { useEffect, useState } from "react";

// Simple class name utility function
function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}

function Input({
  className,
  inputError,
  showPassword,
  setShowPassword,
  highlightEmail,
  placeholder,
  type,
  ...props
}) {

  // Domain-based styles
  const inputHeight = "!h-[56px]";
  const textSize = "text-size-13 placeholder:text-size-13 placeholder:text-[#D1D5DB]";
  const topSpacing = "top-[21px]";
  const [inputType, setInputType] = useState("text");


  useEffect(() => {
    if (type) {
      setTimeout(() => setInputType(type), 200);
    }
  }, [type]);

  return (
    <div className="relative">
      <input
        type={inputType}
        data-slot="input"
        placeholder={placeholder}
        className={cn(
          "w-full px-4 border rounded-7 bg-white text-primary-blue placeholder-gray-300 focus:outline-none transition-all duration-200",
          inputHeight,
          textSize,
          inputError
            ? "border-red"
            : highlightEmail
              ? "border-blue"
              : "border-purple-100 hover:border-purple-100 active:border-blue",
          inputError
            ? ""
            : "focus:ring-1 focus:ring-blue focus:border-transparent",
          type === "password" ? "pr-14" : type === "email" ? "pr-10" : "pr-4",
          className
        )}
        {...props}
      />

      <div className={cn("absolute right-4 flex gap-3", topSpacing)}>
        {/* Password visibility toggle */}
        {(type === "password" || type === "text") &&
          (showPassword ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="#C1C1C1"
              className="size-4 cursor-pointer"
              onClick={() => setShowPassword(false)}
            >
              <path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
              <path
                fillRule="evenodd"
                d="M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 0 1 0-1.113ZM17.25 12a5.25 5.25 0 1 1-10.5 0 5.25 5.25 0 0 1 10.5 0Z"
                clipRule="evenodd"
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="#C1C1C1"
              className="size-4 cursor-pointer"
              onClick={() => setShowPassword(true)}
            >
              <path d="M3.53 2.47a.75.75 0 0 0-1.06 1.06l18 18a.75.75 0 1 0 1.06-1.06l-18-18ZM22.676 12.553a11.249 11.249 0 0 1-2.631 4.31l-3.099-3.099a5.25 5.25 0 0 0-6.71-6.71L7.759 4.577a11.217 11.217 0 0 1 4.242-.827c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113Z" />
              <path d="M15.75 12c0 .18-.013.357-.037.53l-4.244-4.243A3.75 3.75 0 0 1 15.75 12ZM12.53 15.713l-4.243-4.244a3.75 3.75 0 0 0 4.244 4.243Z" />
              <path d="M6.75 12c0-.619.107-1.213.304-1.764l-3.1-3.1a11.25 11.25 0 0 0-2.63 4.31c-.12.362-.12.752 0 1.114 1.489 4.467 5.704 7.69 10.675 7.69 1.5 0 2.933-.294 4.242-.827l-2.477-2.477A5.25 5.25 0 0 1 6.75 12Z" />
            </svg>
          ))}

        {/* Clear (X) icon */}
        {(type === "email" || type === "password" || type === "text") &&
          !highlightEmail &&
          props.value && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="#b2b4c5"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="size-4 text-gray-200 cursor-pointer"
              onClick={() => {
                if (props.onChange) {
                  const event = {
                    ...props,
                    target: { value: "" },
                  };
                  props.onChange(event);
                }
              }}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          )}
      </div>
    </div>
  );
}

export { Input };